<script>
export default {
  methods: {
    isVideo(item) {
      const videoKeys = [
        'videoMp4Link',
        'videoWebmLink',
        'videoYoutubeLink',
        'videoMp4TabletLink',
        'videoWebmTabletLink',
        'videoYoutubeTabletLink',
        'videoMp4MobileLink',
        'videoWebmMobileLink',
        'videoYoutubeMobileLink',
      ];

      for (const key of videoKeys) {
        const link = item[key]?.value;
        switch (true) {
          case key.includes('Youtube') && !!link?.url:
          case !key.includes('Youtube') && !!link?.href:
            return true;
        }
      }

      return false;
    },
  },
};
</script>
